/*
 File: slide-tracking.js
 Author: D McCleod
 Created: 3/8/2017
 Description: fire virtual tracking calls for infinitescroll slideshow
 Note: additional method for calculating inview element: https://gomakethings.com/how-to-test-if-an-element-is-in-the-viewport-with-vanilla-javascript/
 */


import { currentHash, getHash } from './hash-manager';
import { instreamAd } from './instream-ad';
// TODO: (if required) update hash when a new slide is in view


const win = $(window);
const winHeight = win.height() === window.outerHeight ? win.height() : window.outerHeight;
const percent = 0.50;
const winPercent = Math.round(winHeight * percent);
// for uknown reason, jQuerie's .height() is returning an incorrect value

let trackScroll = null;
const infiniteScrollTracking = {
    percent: percent,
    winHeight: winHeight,
    winPercent: winPercent,
    currentSlide: null,
    slideDivs: $('.crs-slide'),
    elementVisible: require('element-visible'),
    lastHash: null,
    slideID: null,
    hashNo : 1,
    lastPos: win.scrollTop(),
    randomTimes: [
        15,
        20,
        25
    ],
    refreshTime: null,
    trackingHeight: window.innerHeight * 1.5,
    scrollDirection: null,

    init:function(){
        let that = this;

        setTimeout(function(){
            $(window).on('scroll', function() {
                clearTimeout(trackScroll);
                trackScroll = setTimeout(function() {
                    infiniteScrollTracking.trackPing2();
                }, 1000);
            });

            that.currentSlide = that.setCurrentSlide([that.getVisibleSlide( that.getScrollDirection() ? 'down' : 'up') + 1]);

        },500);
        return this;
    },

    getRefreshTime: function(){
        this.refreshTime = this.randomTimes[ Math.round(Math.floor( Math.random() * 3 ) + 1) -1 ];
        wmdPageLink('ss-adref_' + this.refreshTime);
        return this.refreshTime;
    },

    refreshMobileAdTimeOut: function(refreshTime) {
        this.refreshMobileAd(refreshTime);
        const that = this;

        $(document).on('dfpRenderComp', function () {
            setTimeout(function(){
                that.refreshMobileAd(refreshTime);
            }, refreshTime * 1000);
        });
    },

    refreshMobileAd: function(refreshTime){
        webmd.ads2.refresh({
            pos:1005,
            keys: {pvid:s_pageview_id,ep:'0', adref: refreshTime}
        });
    },

    trackPing2:function(){
        let currentPos = Math.round(this.lastPos + this.trackingHeight);
        this.scrollDirection = this.getScrollDirection() ? 'down' : 'up';
        let slideID = this.getVisibleSlide(this.scrollDirection);

        if(currentPos < win.scrollTop()){
            wmdTrack('ss-scrdn_'+this.hashNo);
            wmdPageview(window.slideShow.cononical+'-'+ slideID +'-'+this.hashNo, this.hashNo);
            BItrack(slideID + '_' + this.hashNo);
            ++ this.hashNo;
            this.lastPos= win.scrollTop();
        } else {
            if(this.lastPos - this.trackingHeight > win.scrollTop()){
                wmdTrack('ss-scrup'+'_'+ this.hashNo);
                wmdPageview(window.slideShow.cononical+'-'+ slideID +'-'+ this.hashNo, this.hashNo);
                BItrack(slideID + '_' + this.hashNo);
                ++ this.hashNo;
                this.lastPos= win.scrollTop();
            }
        }
        if(this.lastPos+ this.trackingHeight < win.scrollTop() || this.lastPos- this.trackingHeight > win.scrollTop()) {
            this.lastPos= win.scrollTop();
        }

        this.currentSlide = this.setCurrentSlide(slideID);

        return this;
    },

    scrollToSlide: function(hash){
        var padding = 70; // set to below sticky header
        $('html, body').animate({
            scrollTop: $('[data-slidenumber='+ hash +']').offset().top - padding
        }, 500);
    },

    setCurrentSlide: function(id){
        this.currentSlide = $('[data-slidenumber='+ id +']');
        return this.currentSlide;
    },

    getVisibleSlide: function(direction){
        const that = this,
        slideInView = $.grep(this.slideDivs, function(s, i) {
            if ($(s).offset().top <= $(window).scrollTop() + that.winPercent && $(s).offset().top + $(s).outerHeight() >= $(window).scrollTop() + that.winPercent) {
                if(direction === 'down'){
                    that.currentSlide = s;
                    return true;
                } else if(direction === 'up') {
                    that.currentSlide = s;
                    return true;
                }
            }
        });
        const sldNumber = parseInt($(slideInView[0]).attr('data-slidenumber'));
        win.trigger('infinite:scroll', {id: sldNumber});
        return sldNumber;
    },

    getSlideID: function(slide){
        return parseInt(slide.attr('data-slidenumber'));
    },

    getSlidePosition: function(slide){
        return Math.abs(slide.getBoundingClientRect().top);
    },

    getScrollDirection: function(){
        return this.lastPos < win.scrollTop();
    }
};

export { infiniteScrollTracking };
